import {makeAutoObservable} from "mobx";
import PackageItem from "../../../model/packageDelivery/packageItem/PackageItem";
import CommonStore from "../../../stores/CommonStore";
import InventoryItem from "../../../model/packageDelivery/inventoryItem/InventoryItem";
import {InventoryItemService} from "../../../service/packageDelivery/InventoryItem/InventoryItemService";
import ReferenceItemPriceResponse from "../../../model/packageDelivery/referenceItemPrice/ReferenceItemPriceResponse";


const ERROR_MAP = {
    unauthorized: ["ERROR_00_401_00"],
}

class AddPackageItemStore {
    public suggestedItems: InventoryItem[];
    public isReferenceItem: boolean;
    public id: string;
    public name: string;
    public amount: number;
    public comments: string;
    public oneItemPrice: number;
    public oneItemFinalPrice: number;
    public itemPrice: number;
    public finalItemPrice: number;
    public weight: number;
    public group: number | null;

    public categoryId?: string

    public commonStore: CommonStore;


    constructor(
        commonStore: CommonStore,
        categoryId?: string,
        packageItem?: PackageItem,
        selectedReferenceItem?: ReferenceItemPriceResponse
    ) {
        this.commonStore = commonStore;
        this.categoryId = categoryId;
        this.suggestedItems = [];
        this.isReferenceItem = selectedReferenceItem != null;

        if (packageItem) {
            this.id = packageItem.id;
            this.name = packageItem.name;
            this.amount = packageItem.amount;
            this.comments = packageItem.comments;

            this.oneItemPrice = packageItem.itemPrice;
            this.oneItemFinalPrice = packageItem.finalItemPrice;
            this.itemPrice = 0;
            this.finalItemPrice = 0;
            this.weight = packageItem.weight;
            this.group = packageItem.group;

            this.getItemPrice();
        } else if (selectedReferenceItem) {
            this.id = selectedReferenceItem.referenceItemId;
            this.name = selectedReferenceItem.referenceItemName;
            this.amount = 1;
            this.comments = "";

            this.oneItemPrice = selectedReferenceItem.cost;
            this.oneItemFinalPrice = selectedReferenceItem.cost;
            this.itemPrice = selectedReferenceItem.cost;
            this.finalItemPrice = this.itemPrice;
            this.weight = 0;
            this.group = null;
        } else {
            this.id = "";
            this.name = "";
            this.amount = 1;
            this.comments = "";

            this.oneItemPrice = 0;
            this.oneItemFinalPrice = 0;
            this.itemPrice = 0;
            this.finalItemPrice = 0;
            this.weight = 0;
            this.group = null;
        }

        makeAutoObservable(this);
    }

    public onPackageItemSave(): PackageItem {
        return new PackageItem(
            this.id,
            this.name,
            this.amount,
            this.comments,

            this.itemPrice,
            this.finalItemPrice,
            this.weight,
            this.group
        );
    }

    public resetItem() {
        this.id = "";
        this.name = "";
        this.amount = 1;
        this.comments = "";

        this.oneItemPrice = 0;
        this.oneItemFinalPrice = 0;
        this.weight = 0;
        this.group = null;
        this.getItemPrice();
    }

    private getItemPrice() {
        this.itemPrice = parseFloat(parseFloat((this.oneItemPrice * this.amount).toFixed(3)).toFixed(2));
        this.finalItemPrice = parseFloat(parseFloat((this.oneItemFinalPrice * this.amount).toFixed(3)).toFixed(2));
    }


    public async setName(newName: string) {
        this.name = newName;
        this.getInventoryItems(newName);
    }

    public setAmount(newAmount: number) {
        this.amount = newAmount;
        this.getItemPrice();
    }

    private async getInventoryItems(name: string) {
        const response = await InventoryItemService.get(1, 10, name);
        this.commonStore.processErrors(response);
        this.processError(response.error);

        if (response.data?.data == null || response.data?.data.length === 0) {
            this.id = '';
        }

        if (response.success) {
            this.suggestedItems = response.data?.data || [];
        } else {
            this.suggestedItems = [];
        }
    }

    processError(error?: string) {
        if (error) {
            if (ERROR_MAP.unauthorized.includes(error)) {
                this.commonStore.showErrorToast(error); //DONT SHOW THE TOAST BECAUSE IT TRGGERS THE SEACH AGAIN OR DO THE LOGOUT
            }
        }
    }

    public setSelectedItem(itemId?: string) {
        const selectedItem = this.suggestedItems.find(e => e.id === itemId);
        if (selectedItem != null) {
            this.id = selectedItem.id;
            this.name = selectedItem.name;
            this.comments = selectedItem.comments;
            this.oneItemPrice = selectedItem.price;
            this.oneItemFinalPrice = selectedItem.price;
            this.getItemPrice();
        }
    }

    //ItemPrice
    public setFinalItemPrice(newFinalItemPrice: number) {
        this.finalItemPrice = newFinalItemPrice;
    }

    public setWeight(weight: number) {
        this.weight = weight;
    }

    public setGroup(group: number | null) {
        this.group = group;
    }

}

export default AddPackageItemStore;